import { businessErrorFactory, BusinessError } from '../../../business-error';

import { REGENERATE_REPORT_BUSINESS_ERRORS } from './interfaces';

const REGENERATE_REPORT_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error and report could not be regenerated. Please try again. If the problem still persists, contact with support.';

const REGENERATE_REPORT_REPORT_NOT_FOUND =
  // eslint-disable-next-line max-len
  'Sorry but this report could not be found and regenerated. It is possible that the report has been deleted. Please refresh the page. If the problem still persists, contact with support.';

const REGENERATE_REPORT_LIMIT_REACHED =
  // eslint-disable-next-line max-len
  'Sorry but you reached reports limit and you can not regenerate this report. If you still want to regenerate it then please delete one of the existing or contact with support to increase your limit.';

export const getRegenerateReportBusinessError = (businessError: REGENERATE_REPORT_BUSINESS_ERRORS): BusinessError => {
  switch (businessError) {
    case REGENERATE_REPORT_BUSINESS_ERRORS.REPORT_NOT_FOUND: {
      return businessErrorFactory({ message: REGENERATE_REPORT_REPORT_NOT_FOUND, severity: 'warning' });
    }
    case REGENERATE_REPORT_BUSINESS_ERRORS.REPORTS_LIMIT_REACHED: {
      return businessErrorFactory({ message: REGENERATE_REPORT_LIMIT_REACHED, severity: 'warning' });
    }
    default: {
      return businessErrorFactory({
        message: REGENERATE_REPORT_UNEXPECTED_ERROR,
        severity: 'error'
      });
    }
  }
};
